// Site-wide settings. SITE_URL, SOURCE_URL and ENABLE_OFFICE come from the
// build environment (see vite.config.ts and the README).

export const SITE_URL = __SITE_URL__;
export const OFFICE_ENABLED = __OFFICE_ENABLED__;
export const APP_VERSION = __APP_VERSION__;
/** Public repository: the AGPL requires offering the source to every visitor. */
export const SOURCE_URL = __SOURCE_URL__;

export const NETSERENO_URL = 'https://netsereno.com/';
export const RESOURCES_URL = 'https://netsereno.com/recursos.php';

type Campaign = 'header' | 'footer' | 'home-cta' | 'result';

function withUtm(url: string, campaign: Campaign): string {
  const params = new URLSearchParams({ utm_source: 'netsereno-pdf', utm_medium: 'free-resource', utm_campaign: campaign });
  return `${url}?${params}`;
}

/**
 * Links back to netsereno.com carry UTM parameters so the main site can
 * attribute visits to this free resource. Nothing is tracked here.
 */
export function netserenoLink(campaign: Campaign): string {
  return withUtm(NETSERENO_URL, campaign);
}

export function resourcesLink(campaign: Campaign): string {
  return withUtm(RESOURCES_URL, campaign);
}
